import { request } from "../../Services/Api"

export const getAdminUsers = (params) => request.api.get(`/admin_panel/admin-users/`, params)

export const getAdminUsersCount = (params) =>
  request.api.get(`/admin_panel/admin-users/count/`, params)

export const getAdminUsersInviteRoles = (params) =>
  request.api.get(`/admin_panel/admin-users/invite-roles/`, params)

export const getAdminUsersExport = (params) =>
  request.api.get(`/admin_panel/admin-users/export/`, params)

export const updateAdminUserRole = ({ id, ...data }) =>
  request.api.patch(`/admin_panel/admin-users/${id}/update-role/`, data)

export const inviteAdminUser = (data) => request.api.post(`/admin_panel/admin-users/invite/`, data)

export const resendAdminUserInvite = (id) =>
  request.api.post(`/admin_panel/admin-users/${id}/resend-invite/`)

export const deleteAdminUser = (id) => request.api.delete(`/admin_panel/admin-users/${id}/delete/`)
